
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-revigres/favorites",
      function () {
        return require("private-next-pages/my-revigres/favorites/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-revigres/favorites"])
      });
    }
  